const filterImages = (data, key) => {
    var dataArr = [];
    dataArr = data.filter((item) => {
        return item.image_position === key
    });

    return dataArr;
};

export default filterImages;